
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class YanginSigortaVergisiBasvuruAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "YsvBasvuruSave/YsvBasvuruSave";
        super(baseUrl);
    }


    saveYsvBasvuru(request: YsvBasvuruSaveRequest) {

        return this.post("", request,true);

    }

}
export default new YanginSigortaVergisiBasvuruAPI();

class YsvBasvuruSaveRequest {
    basvuruTuruId: number;
    sicilKodu: number;
    beyanYili: number;
    beyanAyi: number;
    vergiyeTabiMenkulPrim?: number;
    vergiyeTabiGmenkulPrim?: number;
    yanginSigortaMnkOran?: number;
    yanginSigortaGmnkOrani?: number;
    menkulOdenecekVergi?: number;
    gmenkulOdenecekVergi?: number;
    topVergiyeTabiPrim?: number;
    topOdeneckVergi?: number;
    aciklama?: string;
    ipAdresi?: string;
    kaydeden?: string;
    captchaToken?: string;

    constructor(
        basvuruTuruId: number,
        sicilKodu: number,
        beyanYili: number,
        beyanAyi: number,
        vergiyeTabiMenkulPrim?: number,
        vergiyeTabiGmenkulPrim?: number,
        yanginSigortaMnkOran?: number,
        yanginSigortaGmnkOrani?: number,
        menkulOdenecekVergi?: number,
        gmenkulOdenecekVergi?: number,
        topVergiyeTabiPrim?: number,
        topOdeneckVergi?: number,
        aciklama?: string,
        ipAdresi?: string,
        kaydeden?: string,
        captchaToken?: string
    ) {
        this.basvuruTuruId = basvuruTuruId;
        this.sicilKodu = sicilKodu;
        this.beyanYili = beyanYili;
        this.beyanAyi = beyanAyi;
        this.vergiyeTabiMenkulPrim = vergiyeTabiMenkulPrim;
        this.vergiyeTabiGmenkulPrim = vergiyeTabiGmenkulPrim;
        this.yanginSigortaMnkOran = yanginSigortaMnkOran;
        this.yanginSigortaGmnkOrani = yanginSigortaGmnkOrani;
        this.menkulOdenecekVergi = menkulOdenecekVergi;
        this.gmenkulOdenecekVergi = gmenkulOdenecekVergi;
        this.topVergiyeTabiPrim = topVergiyeTabiPrim;
        this.topOdeneckVergi = topOdeneckVergi;
        this.aciklama = aciklama;
        this.ipAdresi = ipAdresi;
        this.kaydeden = kaydeden;
        this.captchaToken = captchaToken;
    }
}
export { YsvBasvuruSaveRequest };